import { BILL_TYPE, PROVIDER_TYPE } from 'utils/enums';
import { LOCALE } from 'utils/enums/locale.enum';
import {
	IAddServiceFieldValueRequest,
	IPaginatedResponse,
	IServicesCategoriesItemResponse,
	IServicesCategoriesRequest,
	IServicesItemResponse,
	ServicesRequest,
} from 'utils/types';

export const DEFAULT_SERVICE_LIST_DATA = {
	listData: {
		showedFrom: 0,
		totalRows: 0,
		showedTo: null,
	},
};

export const DEFAULT_SERVICES_CATEGORIES_PAGINATED_DATA: IPaginatedResponse<IServicesCategoriesItemResponse> = {
	...DEFAULT_SERVICE_LIST_DATA,
	tableData: [],
};

export const DEFAULT_SERVICES_PAGINATED_DATA: IPaginatedResponse<IServicesItemResponse> = {
	...DEFAULT_SERVICE_LIST_DATA,
	tableData: [],
};

export const DEFAULT_ADD_SERVICE_VALUE: IAddServiceFieldValueRequest = {
	userId: '',
	serviceId: '',
	name: '',
	value: '',
	apartmentAccountId: null,
};

export const SERVICES_CATEGORIES_DEFAULT_REQUEST_BODY: IServicesCategoriesRequest = {
	offset: 0,
	limit: 12,
	locale: LOCALE.UK,
	options: {
		serviceCategoryTitle: '',
	},
	billType: BILL_TYPE.EK,
};

export const SERVICES_DEFAULT_REQUEST_BODY: ServicesRequest = {
	offset: 0,
	limit: 12,
	locale: LOCALE.UK,
	options: {
		serviceTitle: '',
		serviceCategoryId: [],
		// eslint-disable-next-line max-len
		provider: [PROVIDER_TYPE.NAFTOGAS, PROVIDER_TYPE.HEZ, PROVIDER_TYPE.PORTMONE, PROVIDER_TYPE.MEGOGO, PROVIDER_TYPE.HCS, PROVIDER_TYPE.KTS, PROVIDER_TYPE.KVBO, PROVIDER_TYPE.KVD],
	},
};

export const PORTMONE_AMOUNT_FIELD_NAME = 'amount';

export const PORTMONE_SERVICE_CODE = {
	NAFTOGAS: '1017P',
	ENERGOZBUT: '620P',
};
